import api from 'clients/api/Api';

interface ICfmVerifyResponse {
  data: { name: string; isActive: boolean; inscriptionSituation: string } | null;
  hasError: boolean;
  error: string | null;
}

const verifyUserIsValid = async (crm: string, uf: string): Promise<ICfmVerifyResponse> => {
  const { data } = await api.get<ICfmVerifyResponse>('cardio/Cfm/VerifyUserIsValid', {
    params: { crm, uf },
  });
  return data;
};

export const CfmService = { verifyUserIsValid };
